import { render } from "./2022-10-26-Dom event.md?vue&type=template&id=afd08ae4"
import script from "./2022-10-26-Dom event.md?vue&type=script&lang=js"
export * from "./2022-10-26-Dom event.md?vue&type=script&lang=js"
script.render = render

export default script